import { ApolloClient, InMemoryCache, HttpLink, ApolloLink } from '@apollo/client';

// Integrations API Apollo Client
export const createIntegrationsClient = (getAccessTokenSilently) => {
  const httpLink = new HttpLink({
    uri: process.env.REACT_APP_GRAPHQL_ENDPOINT || 'https://ttylf2win0.execute-api.us-east-1.amazonaws.com/graphql',
  });

  const authLink = new ApolloLink(async (operation, forward) => {
    // Get Auth0 token before making the request
    const token = await getAccessTokenSilently({
      authorizationParams: {
        audience: process.env.REACT_APP_API_AUDIENCE,
        scope: "openid profile email"
      }
    });

    // Set authorization header
    operation.setContext({
      headers: {
        authorization: token ? `Bearer ${token}` : "",
      }
    });

    return forward(operation);
  });

  return new ApolloClient({
    link: authLink.concat(httpLink),
    cache: new InMemoryCache(),
    defaultOptions: {
      watchQuery: {
        fetchPolicy: 'network-only',
      },
      query: {
        fetchPolicy: 'network-only',
      },
    },
  });
};
